export type Tono = 'neutro' | 'info' | 'exito' | 'alerta' | 'peligro' | 'primario';

/** Estado visible de un importe (spec funcional §9.3). */
export type EstadoImporte = 'registrado' | 'validado' | 'aprobado' | 'enviado_nomina' | 'pagado';

export const ETIQUETA_ESTADO_IMPORTE: Record<EstadoImporte, string> = {
  registrado: 'Registrado',
  validado: 'Validado',
  aprobado: 'Aprobado',
  enviado_nomina: 'Enviado a nómina',
  pagado: 'Pagado',
};

/** Traduce estados internos (evento, movimiento, periodo) al estado visible del importe. */
export function estadoImporteDesde(estado: string | null | undefined): EstadoImporte {
  switch (estado) {
    case 'validado':
      return 'validado';
    case 'aprobado':
    case 'generado':
      return 'aprobado';
    case 'enviado_nomina':
    case 'enviado_a_nomina':
    case 'acusado':
      return 'enviado_nomina';
    case 'pagado':
      return 'pagado';
    default:
      return 'registrado';
  }
}

const ESTADOS: Record<string, { etiqueta: string; tono: Tono }> = {
  // eventos
  pendiente: { etiqueta: 'Pendiente', tono: 'alerta' },
  validado: { etiqueta: 'Validado', tono: 'info' },
  aprobado: { etiqueta: 'Aprobado', tono: 'exito' },
  cuarentena: { etiqueta: 'En cuarentena', tono: 'peligro' },
  anulado: { etiqueta: 'Anulado', tono: 'neutro' },
  rechazado: { etiqueta: 'Rechazado', tono: 'peligro' },
  // jornadas
  abierta: { etiqueta: 'Abierta', tono: 'info' },
  cerrada: { etiqueta: 'Por validar', tono: 'alerta' },
  validada: { etiqueta: 'Validada', tono: 'exito' },
  reabierta_web: { etiqueta: 'Reabierta', tono: 'alerta' },
  // periodo
  abierto: { etiqueta: 'Abierto', tono: 'info' },
  en_calculo: { etiqueta: 'En cálculo', tono: 'info' },
  calculado: { etiqueta: 'Calculado', tono: 'info' },
  revision_campo: { etiqueta: 'Revisión de campo', tono: 'alerta' },
  aprobacion_contratistas: { etiqueta: 'Aprobación contratistas', tono: 'alerta' },
  enviado_nomina: { etiqueta: 'Enviado a nómina', tono: 'primario' },
  cerrado: { etiqueta: 'Cerrado', tono: 'neutro' },
  // tarifarios, metas, bonos
  borrador: { etiqueta: 'Borrador', tono: 'neutro' },
  en_aprobacion: { etiqueta: 'En aprobación', tono: 'alerta' },
  vigente: { etiqueta: 'Vigente', tono: 'exito' },
  reemplazado: { etiqueta: 'Reemplazado', tono: 'neutro' },
  superada: { etiqueta: 'Superada', tono: 'neutro' },
  autorizado: { etiqueta: 'Autorizado', tono: 'info' },
  publicado: { etiqueta: 'Publicado', tono: 'exito' },
  vencido: { etiqueta: 'Vencido', tono: 'neutro' },
  // movimientos y lotes
  generado: { etiqueta: 'Generado', tono: 'info' },
  enviado_a_nomina: { etiqueta: 'Enviado a nómina', tono: 'primario' },
  acusado: { etiqueta: 'Acusado', tono: 'exito' },
  rechazado_nomina: { etiqueta: 'Rechazado por nómina', tono: 'peligro' },
  pagado: { etiqueta: 'Pagado', tono: 'exito' },
  disponible: { etiqueta: 'Disponible', tono: 'info' },
  descargado: { etiqueta: 'Descargado', tono: 'primario' },
  acusado_parcial: { etiqueta: 'Acuse parcial', tono: 'alerta' },
  error: { etiqueta: 'Error', tono: 'peligro' },
  // reclamos
  asignado: { etiqueta: 'Asignado', tono: 'info' },
  resuelto: { etiqueta: 'Resuelto', tono: 'exito' },
  // personas, dispositivos, integraciones
  activo: { etiqueta: 'Activo', tono: 'exito' },
  inactivo: { etiqueta: 'Inactivo', tono: 'neutro' },
  en_conflicto: { etiqueta: 'En conflicto', tono: 'peligro' },
  bloqueado: { etiqueta: 'Bloqueado', tono: 'peligro' },
  perdido: { etiqueta: 'Perdido', tono: 'peligro' },
  ok: { etiqueta: 'OK', tono: 'exito' },
  parcial: { etiqueta: 'Parcial', tono: 'alerta' },
  // cargas
  recibida: { etiqueta: 'Recibida', tono: 'info' },
  validando: { etiqueta: 'Validando', tono: 'info' },
  con_errores: { etiqueta: 'Con errores', tono: 'peligro' },
  lista: { etiqueta: 'Lista para aplicar', tono: 'exito' },
  aplicada: { etiqueta: 'Aplicada', tono: 'exito' },
  cancelada: { etiqueta: 'Cancelada', tono: 'neutro' },
  // importes
  registrado: { etiqueta: 'Registrado', tono: 'alerta' },
};

export function describirEstado(estado: string | null | undefined): { etiqueta: string; tono: Tono } {
  if (!estado) return { etiqueta: '—', tono: 'neutro' };
  return ESTADOS[estado] ?? { etiqueta: estado.replace(/_/g, ' '), tono: 'neutro' };
}
